import React, { useEffect, useRef, useState } from "react";
import { auth } from "../../firebase/firebase";
import { signOut } from "firebase/auth";
import Signup from "../Signup/Signup";
import Login from "../Login/Login";
import { useNavigate } from "react-router-dom";
import { isUnverifiedPasswordUser } from "../../firebase/authVerification";
import VerifyEmailModal from "../UploadTabu/VerifyEmailModal";

function PrivateRoute({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showSignup, setShowSignup] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [verifyEmail, setVerifyEmail] = useState("");
  const [redirectAfterAuth, setRedirectAfterAuth] = useState(false); // חדש
  const blockedUnverifiedRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (u) => {
      if (isUnverifiedPasswordUser(u)) {
        blockedUnverifiedRef.current = true;
        setUser(null);
        setLoading(false);
        setShowSignup(false);
        setShowLogin(false);
        setVerifyEmail(u?.email || "");
        setShowVerifyModal(true);
        setRedirectAfterAuth(true);
        return;
      }

      setUser(u);
      setLoading(false);

      if (!u) {
        if (blockedUnverifiedRef.current) {
          blockedUnverifiedRef.current = false;
          setShowSignup(false);
          setShowLogin(false);
        } else {
          setShowSignup(true);
          setShowLogin(false);
        }
        setRedirectAfterAuth(true); // ✅ סמן שהגענו לעמוד מוגן
      } else {
        setShowSignup(false);
        setShowLogin(false);
        setShowVerifyModal(false);
        // 🧠 אם זה היה ניסיון גישה מוגן → נשלח לעמוד הבית פעם אחת בלבד
        if (redirectAfterAuth) {
          setRedirectAfterAuth(false); // כדי לא להחזיר שוב בהמשך
          navigate("/"); // מעבר לעמוד הבית
        }
      }
    });

    return () => unsubscribe();
  }, [navigate, redirectAfterAuth]);

  if (loading) return null;

  if (!user) {
    return (
      <>
        {showVerifyModal && (
          <VerifyEmailModal
            isOpen={showVerifyModal}
            email={verifyEmail}
            onClose={async () => {
              setShowVerifyModal(false);
              await signOut(auth);
              navigate("/");
            }}
          />
        )}
        {showSignup && (
          <Signup
            isFromProtectedRoute={true}
            onClose={() => navigate("/")}
            onSwitchToLogin={() => {
              setShowSignup(false);
              setShowLogin(true);
            }}
          />
        )}
        {showLogin && (
          <Login
            isFromProtectedRoute={true}
            onClose={() => navigate("/")}
            onSwitchToSignup={() => {
              setShowLogin(false);
              setShowSignup(true);
            }}
          />
        )}
      </>
    );
  }

  // ✅ המשתמש מחובר וניגש לעמוד מוגן – מותר להציג לו אותו
  return children;
}

export default PrivateRoute;
